'use client'

import { ABHA_HERO_SUCCESS_TITLE_DESKTOP } from '@components/NewProduct/constants'
import { AbhaHeroSuccessContentSection } from '@components/NewProduct/AbhaHeroWidget/steps/AbhaHeroSuccessContentSection'
import { AbhaHeroSuccessPanelHeader } from '@components/NewProduct/AbhaHeroWidget/steps/AbhaHeroSuccessPanelHeader'
import type { AbhaSuccessPanelPlatformData } from '@components/NewProduct/AbhaHeroWidget/steps/abhaSuccessRightPanelTypes'
import { normalizeSuccessPanelData } from '@components/NewProduct/AbhaHeroWidget/steps/normalizeSuccessPanelData'
import './abhaHeroSuccessRightPanel.css'

export type AbhaHeroSuccessRightPanelProps = {
  data?: {
    desktopData?: AbhaSuccessPanelPlatformData
  }
  appDownloadLink: string
  ctaAnalyticsProps?: Record<string, unknown>
}

export const AbhaHeroSuccessRightPanel = ({
  data,
  appDownloadLink,
  ctaAnalyticsProps,
}: AbhaHeroSuccessRightPanelProps) => {
  const panelData = normalizeSuccessPanelData(data?.desktopData, {
    title: ABHA_HERO_SUCCESS_TITLE_DESKTOP,
    appLink: appDownloadLink,
  })

  return (
    <div
      className={[
        'abha-hero-success__desktop-panel',
        'abha-hero-success-panel',
        `abha-hero-success-panel--${panelData.panelVariant}`,
      ].join(' ')}>
      <AbhaHeroSuccessPanelHeader header={panelData.header} align="left" />

      <AbhaHeroSuccessContentSection
        panelData={panelData}
        appDownloadLink={appDownloadLink}
        ctaAnalyticsProps={ctaAnalyticsProps}
      />
    </div>
  )
}
